import { render, staticRenderFns } from "./InvoiceClientFields.vue?vue&type=template&id=5bf9559d&"
import script from "./InvoiceClientFields.vue?vue&type=script&lang=js&"
export * from "./InvoiceClientFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports